var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M16 10a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6.586L20.586 10zm-3 1a3 3 0 0 1 3-3h4.586A2 2 0 0 1 22 8.586L26.414 13A2 2 0 0 1 27 14.414V21a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3h1zm0 3h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h-5a3 3 0 0 1-3-3z"
  })));
};
export default SvgDocument;